import React from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import DownloadReportIcon from '../../icons/DownloadReportIcon.jsx';
import { AddOrgStakeholderLink } from '../../links/index.jsx';
import { EditBlueIcon } from '../../icons/EditBlueIcon.jsx';
import AuthorizedAction from '../../AuthorizedAction.js';
import CustomMenuItem from '../../CustomMenuItem.jsx';

const StakeholdersActionsDropdown = ({
  onDownloadCsv,
  isReportLoading,
  isCanManageStructure,
}) => {
  return (
    <div className="actions">
      <DropdownButton
        noCaret
        title=""
        id="id"
        className="btn-more btn btn-default"
      >
        {isCanManageStructure ? (
          <AddOrgStakeholderLink>
            <CustomMenuItem>
              <span className="flex">
                <EditBlueIcon />
                <span className="m-l-8">&nbsp; Edit</span>
              </span>
            </CustomMenuItem>
            <MenuItem divider />
          </AddOrgStakeholderLink>
        ) : null}

        <AuthorizedAction action="read" subject="organizationStakeholder">
          <CustomMenuItem>
            <button
              className="flex flex-align-center h-100 w-100 p-0 btn-clear bg-transparent"
              onClick={onDownloadCsv}
            >
              <DownloadReportIcon />
              &nbsp;
              <span className="m-l-8">
                {isReportLoading ? 'Loading...' : 'Download CSV'}
              </span>
            </button>
          </CustomMenuItem>
        </AuthorizedAction>
      </DropdownButton>
    </div>
  );
};

export default StakeholdersActionsDropdown;
